const toast = {
  message: {
    success: 'Success!',
    error: 'Something went wrong.',
  },
};

export default toast;
